document.addEventListener('DOMContentLoaded', function () {
  var navToggle = document.querySelector('[data-nav-toggle]');
  var siteNav = document.querySelector('[data-site-nav]');
  if (navToggle && siteNav) {
    navToggle.addEventListener('click', function () {
      siteNav.classList.toggle('is-open');
    });
  }

  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOpeners = document.querySelectorAll('[data-cart-open]');
  var cartClosers = document.querySelectorAll('[data-cart-close]');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('is-open');
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
  }
  cartOpeners.forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      openCart();
    });
  });
  cartClosers.forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      closeCart();
    });
  });

  function renderCartDrawer(cart) {
    var body = document.querySelector('[data-cart-body]');
    var foot = document.querySelector('[data-cart-foot]');
    var countEls = document.querySelectorAll('[data-cart-count]');
    countEls.forEach(function (el) { el.textContent = cart.item_count; });

    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty. Add some ghee to get started.</p>';
      if (foot) foot.innerHTML = '';
      return;
    }

    var html = '';
    cart.items.forEach(function (item) {
      html += '' +
        '<div class="cart-line">' +
        '<img src="' + item.image + '" alt="' + item.product_title + '">' +
        '<div>' +
        '<div class="cart-line__title">' + item.product_title + '</div>' +
        '<div class="cart-line__price">Qty ' + item.quantity + ' &middot; ' + formatMoney(item.final_line_price) + '</div>' +
        '</div>' +
        '</div>';
    });
    body.innerHTML = html;

    if (foot) {
      foot.innerHTML = '' +
        '<div class="cart-subtotal"><span>Subtotal</span><span>' + formatMoney(cart.total_price) + '</span></div>' +
        '<a href="/checkout" class="btn btn-primary btn-block">Checkout</a>';
    }
  }

  function formatMoney(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0 });
  }

  function refreshCart() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(renderCartDrawer)
      .catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-add-to-cart-form]')) return;
    e.preventDefault();
    var formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' }
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        refreshCart();
        openCart();
      })
      .catch(function () {});
  });

  document.addEventListener('click', function (e) {
    var stepper = e.target.closest('[data-qty-decrease],[data-qty-increase]');
    if (!stepper) return;
    var wrapper = stepper.closest('.qty-stepper');
    var input = wrapper.querySelector('input[type="number"]');
    var value = parseInt(input.value || '1', 10);
    if (stepper.hasAttribute('data-qty-decrease')) value = Math.max(1, value - 1);
    if (stepper.hasAttribute('data-qty-increase')) value = value + 1;
    input.value = value;
  });

  refreshCart();

  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    var variantsScript = productForm.querySelector('[data-product-variants]');
    var variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    var variantIdInput = productForm.querySelector('[data-variant-id-input]');
    var pickers = productForm.querySelectorAll('.variant-picker');

    function currentSelection() {
      var selected = [];
      pickers.forEach(function (picker) {
        var active = picker.querySelector('.variant-pill.is-active');
        selected.push(active ? active.getAttribute('data-value') : null);
      });
      return selected;
    }

    function findVariant(selected) {
      return variants.find(function (v) {
        return selected.every(function (val, i) {
          return val === null || v.options[i] === val;
        });
      });
    }

    function updatePriceUI(variant) {
      if (!variant) return;
      var priceEl = productForm.querySelector('[data-price]');
      var compareEl = productForm.querySelector('[data-compare-price]');
      var saveBadge = productForm.querySelector('[data-save-badge]');
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (compareEl) { compareEl.textContent = formatMoney(variant.compare_at_price); compareEl.style.display = ''; }
        if (saveBadge) { saveBadge.textContent = 'Save ' + formatMoney(variant.compare_at_price - variant.price); saveBadge.style.display = ''; }
      } else {
        if (compareEl) compareEl.style.display = 'none';
        if (saveBadge) saveBadge.style.display = 'none';
      }
      var submitBtn = productForm.querySelector('button[type="submit"]');
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available ? 'Add to Cart' : 'Sold out';
      }
    }

    pickers.forEach(function (picker) {
      picker.addEventListener('click', function (e) {
        var pill = e.target.closest('.variant-pill');
        if (!pill) return;
        picker.querySelectorAll('.variant-pill').forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        var variant = findVariant(currentSelection());
        if (variant) {
          variantIdInput.value = variant.id;
          updatePriceUI(variant);
        }
      });
    });
  }
});
